import { externalHandoverService } from '@/api/external-handover.service';
import { useMutation, useQueryClient } from '@tanstack/vue-query';
import type { SendExternalHandoverLinkDto } from '@carvia/ros-client-types';
import { invalidateAuthData } from '@/queries/auth/use-login';

export const useSendExternalHandoverLink = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (data: SendExternalHandoverLinkDto) => externalHandoverService.sendLink(data),
    onMutate: () => ({
      successMessage: 'Handover link sent',
      invalidateQueryKeys: null,
    }),
    onSuccess: (result, variables, onMutateResult, context) => {
      queryClient.getMutationDefaults([])?.onSuccess?.(result, variables, onMutateResult, context);
    },
  });
};

export const useExternalHandoverLogin = () =>
  useMutation({
    mutationFn: (token: string) => externalHandoverService.login(token),
    onError: () => undefined,
    onSuccess: async () => {
      await invalidateAuthData();
    },
  });

export const useSendExternalPaymentLink = () =>
  useMutation({
    mutationFn: (bookingId: string) => externalHandoverService.sendPaymentLink(bookingId),
  });
